import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectTotalCount = (store: StoreSchema) =>
	store.licenseEvents.paginatedLicenseEvents.totalCount
